import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom'; // Importez le Router
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router> {/* StrictMode désactivé pour éviter double mount en dev */}
    <App />
  </Router>
);

// Si vous souhaitez mesurer les performances de votre application, passez une fonction
// pour enregistrer les résultats (par exemple : reportWebVitals(console.log))
// ou envoyez-les à un point de terminaison d'analytique. Apprenez-en plus : https://bit.ly/CRA-vitals
console.log("REACT_APP_API_URL:", process.env.REACT_APP_API_URL);

reportWebVitals();